<template>
  <div class="disk-share-records">
    <div class="dsr-card">
      <div class="dsr-head">
        <div class="dsr-title">
          <a class="dsr-back" title="返回网盘" @click="$router.push('/disk/index')"><Icon type="ios-arrow-left" size="18"></Icon></a>
          <span>分享记录</span>
          <span class="dsr-count">{{ filteredList.length }}</span>
        </div>
        <div class="dsr-tabs">
          <a v-for="tab in tabs" :key="tab.key" :class="['dsr-tab', { on: filter === tab.key }]" @click="filter = tab.key">{{ tab.label }}</a>
        </div>
      </div>
      <Table v-show="loading || filteredList.length" :columns="columns" :data="filteredList" :loading="loading" class="dsr-table"></Table>
      <div v-if="!loading && !filteredList.length" class="dsr-empty">
        <Icon type="android-share-alt" size="48"></Icon>
        <div>{{ list.length ? '没有符合条件的分享' : '还没有分享记录' }}</div>
      </div>
    </div>

    <Modal v-model="showLog" class-name="disk-modal" title="访问记录" width="720">
      <Table :columns="logColumns" :data="logList" :loading="logLoading"
             no-data-text="还没有预览或下载"></Table>
      <div slot="footer">
        <Button @click="showLog = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {fileIconOf} from './fileIcon'

export default {
  name: 'DiskShareRecords',
  data () {
    return {
      loading: false,
      list: [],
      showLog: false,
      logLoading: false,
      logList: [],
      filter: 'all',
      columns: [
        {
          title: '分享的文件',
          minWidth: 320,
          render: (h, params) => {
            let row = params.row
            let url = this.buildShareUrl(row.token, row.extractCode)
            let ops = [
              this.opBtn(h, 'ios-copy-outline', '复制链接', () => this.copyText(url)),
              this.opBtn(h, 'ios-list-outline', '访问记录', () => this.openLog(row))
            ]
            if (row.status === 1) {
              ops.push(this.opBtn(h, 'ios-close-outline', '撤销分享', () => this.revoke(row), true))
            }
            return h('div', {class: 'dsr-name-cell'}, [
              h('img', {class: 'dsr-icon', attrs: {src: fileIconOf(row.nodeName, row.nodeType === 1), alt: ''}}),
              h('div', {class: 'dsr-name-main'}, [
                h('a', {class: 'dsr-name', attrs: {href: url, target: '_blank', rel: 'noopener', title: row.nodeName || ''}}, row.nodeName || '-'),
                h('div', {class: 'dsr-sub'}, (row.creatorName ? row.creatorName + ' 分享于 ' : '分享于 ') + this.formatTime(row.gmtCreate))
              ]),
              h('div', {class: 'dsr-ops'}, ops)
            ])
          }
        },
        {
          title: '状态',
          width: 100,
          render: (h, params) => {
            let text = this.statusText(params.row)
            let cls = text === '有效' ? 'ok' : (text === '已过期' ? 'warn' : 'off')
            return h('span', {class: ['dsr-status', cls]}, text)
          }
        },
        {
          title: '提取码',
          width: 90,
          render: (h, params) => h('span', {class: 'dsr-muted'}, params.row.extractCode || '无')
        },
        {
          title: '有效期至',
          width: 170,
          render: (h, params) => h('span', {class: 'dsr-muted'}, params.row.expireTime ? this.formatTime(params.row.expireTime) : '永久有效')
        },
        {
          title: '访问 / 预览 / 下载',
          width: 150,
          align: 'center',
          render: (h, params) => h('span', {class: 'dsr-muted'},
            (params.row.visitCount || 0) + ' / ' + (params.row.previewCount || 0) + ' / ' + (params.row.downloadCount || 0))
        }
      ],
      logColumns: [
        {title: '访问 IP', minWidth: 140, key: 'ip'},
        {
          title: '访问时间',
          width: 170,
          render: (h, params) => h('span', this.formatTime(params.row.gmtCreate))
        },
        {title: '预览次数', width: 100, align: 'center', key: 'previewCount'},
        {title: '下载次数', width: 100, align: 'center', key: 'downloadCount'}
      ]
    }
  },
  computed: {
    tabs () {
      let count = {all: this.list.length, ok: 0, off: 0}
      this.list.forEach(row => {
        if (this.statusText(row) === '有效') {
          count.ok += 1
        } else {
          count.off += 1
        }
      })
      return [
        {key: 'all', label: '全部 ' + count.all},
        {key: 'ok', label: '有效 ' + count.ok},
        {key: 'off', label: '已失效 ' + count.off}
      ]
    },
    filteredList () {
      if (this.filter === 'all') {
        return this.list
      }
      return this.list.filter(row => (this.statusText(row) === '有效') === (this.filter === 'ok'))
    }
  },
  created () {
    this.load()
  },
  methods: {
    opBtn (h, icon, label, handler, danger) {
      return h('Tooltip', {props: {content: label, placement: 'top', transfer: true, delay: 300}}, [
        h('span', {
          class: ['dsr-op-btn', danger ? 'danger' : ''],
          attrs: {role: 'button', 'aria-label': label},
          on: {
            click: function (event) {
              event.stopPropagation()
              handler()
            }
          }
        }, [h('Icon', {props: {type: icon, size: 18}})])
      ])
    },
    load () {
      let self = this
      self.loading = true
      self.$http.get('/disk/share/all').then(function (res) {
        self.loading = false
        if (res && res.status === 'ok') {
          self.list = res.data || []
        }
      }).catch(function () {
        self.loading = false
      })
    },
    statusText (row) {
      if (!row || row.status !== 1) {
        return '已撤销'
      }
      if (row.expireTime && this.$moment(row.expireTime).isBefore(this.$moment())) {
        return '已过期'
      }
      return '有效'
    },
    formatTime (value) {
      if (value == null || value === '') {
        return ''
      }
      if (typeof value === 'number') {
        return this.$moment(value).format('YYYY-MM-DD HH:mm:ss')
      }
      let text = String(value)
      if (/^\d{10,}$/.test(text)) {
        return this.$moment(Number(text)).format('YYYY-MM-DD HH:mm:ss')
      }
      return text
    },
    buildShareUrl (token, extractCode) {
      let url = window.location.origin + window.location.pathname + '#/disk/share?token=' + (token || '')
      if (extractCode) {
        url += '&extractCode=' + extractCode
      }
      return url
    },
    copyText (text) {
      let input = document.createElement('textarea')
      input.value = text
      document.body.appendChild(input)
      input.select()
      try {
        document.execCommand('copy')
        this.$Message.success('已复制')
      } catch (e) {
        this.$Message.error('复制失败，请手动复制')
      }
      document.body.removeChild(input)
    },
    openLog (row) {
      let self = this
      if (!row) {
        return
      }
      self.logList = []
      self.logLoading = true
      self.showLog = true
      self.$http.get('/disk/share/access', {params: {id: row.id}}).then(function (res) {
        self.logLoading = false
        if (res && res.status === 'ok') {
          self.logList = res.data || []
        }
      }).catch(function () {
        self.logLoading = false
      })
    },
    revoke (row) {
      let self = this
      self.$Modal.confirm({
        title: '提示',
        content: '确定撤销该分享链接吗？',
        onOk: function () {
          self.$http.post('/disk/share/revoke', {id: row.id}).then(function (res) {
            if (res && res.status === 'ok') {
              self.$Message.success('已撤销')
              self.load()
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.dsr-card {
  min-height: calc(100vh - 140px);
  padding: 20px 24px;
  border: 1px solid #eef0f4;
  border-radius: 12px;
  background: #fff;
}

.dsr-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.dsr-title {
  display: flex;
  align-items: center;
  font-size: 17px;
  font-weight: 600;
  color: #17233d;
}

.dsr-back {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin-right: 8px;
  border-radius: 6px;
  color: #515a6e;
}

.dsr-back:hover {
  background: #eef2f8;
}

.dsr-count {
  margin-left: 8px;
  color: #a8adb7;
  font-size: 13px;
  font-weight: normal;
}

.dsr-tabs {
  display: flex;
  padding: 3px;
  border-radius: 18px;
  background: #f5f7fa;
}

.dsr-tab {
  padding: 4px 14px;
  border-radius: 15px;
  color: #515a6e;
  font-size: 13px;
}

.dsr-tab.on {
  background: #fff;
  color: #2d8cf0;
  box-shadow: 0 1px 3px rgba(23, 35, 61, 0.1);
}

.dsr-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 100px 0;
  color: #a8adb7;
}

.dsr-empty div {
  margin-top: 12px;
  font-size: 14px;
}

.dsr-table {
  border: none;
}

.dsr-table /deep/ .ivu-table:before,
.dsr-table /deep/ .ivu-table:after {
  display: none;
}

.dsr-table /deep/ .ivu-table-header th {
  background: #fafbfc;
  color: #808695;
  font-weight: normal;
}

.dsr-table /deep/ .ivu-table-body td {
  height: 64px;
  border-bottom-color: #f2f3f5;
}

.dsr-table /deep/ .ivu-table-row:hover td {
  background: #f3f8ff;
}

.dsr-table /deep/ .dsr-name-cell {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 0;
}

.dsr-table /deep/ .dsr-icon {
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  margin-right: 12px;
}

.dsr-table /deep/ .dsr-name-main {
  flex: 1;
  min-width: 0;
}

.dsr-table /deep/ .dsr-name {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #17233d;
  font-size: 14px;
}

.dsr-table /deep/ .dsr-name:hover {
  color: #2d8cf0;
}

.dsr-table /deep/ .dsr-sub {
  margin-top: 2px;
  color: #a8adb7;
  font-size: 12px;
}

.dsr-table /deep/ .dsr-ops {
  position: absolute;
  top: 50%;
  right: 0;
  display: flex;
  padding: 2px 4px;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(23, 35, 61, 0.08);
  transform: translateY(-50%);
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s;
}

.dsr-table /deep/ .ivu-table-row:hover .dsr-ops {
  visibility: visible;
  opacity: 1;
}

.dsr-table /deep/ .dsr-op-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 28px;
  border-radius: 4px;
  color: #2d8cf0;
  cursor: pointer;
}

.dsr-table /deep/ .dsr-op-btn:hover {
  background: #e8f2ff;
}

.dsr-table /deep/ .dsr-op-btn.danger {
  color: #ed4014;
}

.dsr-table /deep/ .dsr-op-btn.danger:hover {
  background: #fff1f0;
}

.dsr-table /deep/ .dsr-muted {
  color: #808695;
}

.dsr-table /deep/ .dsr-status {
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 12px;
}

.dsr-table /deep/ .dsr-status.ok {
  color: #19be6b;
  background: #e8f8ef;
}

.dsr-table /deep/ .dsr-status.warn {
  color: #d46b08;
  background: #fff4e5;
}

.dsr-table /deep/ .dsr-status.off {
  color: #808695;
  background: #f0f2f5;
}
</style>



// WEBPACK FOOTER //
// DiskShareRecords.vue?1e02c1ec